import { CodebookModel } from 'app/shared/model/shared.model';

export interface RpjLocationModel {
  idRpjLocation?: number;
  community: CodebookModel[];
  street: CodebookModel[];
  houseNumber: CodebookModel[];
}

export interface RpjLocationView {
  idRpjLocation: number;
  countyCityMunicipality: string;
  communityStreetHouseNumber: string;
}

export const initialRpjLocation = {
  community: [],
  street: [],
  houseNumber: [],
};

export interface DkpLocationModel {
  idDkpLocation?: number;
  cadastralMunicipality: CodebookModel[];
  parcels: DkpCadastralParcelModel[];
  zkEntry: string;
}

export interface DkpCadastralParcelModel {
  idDkpCadastralParcel?: number;
  cadastralParcel: string;
}

export interface DkpLocationView {
  idDkpLocation: number;
  cadastralMunicipality: string;
  cadastralParcel: string;
}

export const initialDkpLocation = {
  cadastralMunicipality: [],
  parcels: [{idDkpCadastralParcel: 0, cadastralParcel: ''}],
  zkEntry: '',
};
